import { Modal } from '@mui/material';
import React, { useMemo } from 'react';
import {
    Badge,
    CloseButton,
    DividerTitulationModal,
    IdTrackingDiv,
    Name,
    RowDetails,
    WrapperModal,
} from '../../../../styled-components';
import { Text } from '../../../common/Texts';
import TrackingCard from '../../molecules/titulation/TrackingCard';
import { formatDate } from '../../../../utils/dates/dates.utils';
import { Icon } from '@iconify/react';

const DegreeTrackingModal = (props) => {
    const { open, handleCloseModal, tracking } = props;

    const sortedTrackingMessages = useMemo(() => {
        return tracking.state_change_ids?.sort((a, b) => a.id - b.id);
    }, [tracking?.state_change_ids]);

    return (
        <>
            <Modal onClose={handleCloseModal} open={open}>
                <WrapperModal
                    widthModal="320px"
                    maxHeightModal="80vh"
                    gapModal="1rem"
                    topModal="50%"
                    leftModal="50%"
                    minWidthModal="320px"
                >
                    <CloseButton onClick={handleCloseModal}>
                        <Icon
                            icon="iconoir:cancel"
                            width="24px"
                            height="24px"
                        />
                    </CloseButton>
                    <Text
                        fontWeight="600"
                        fontSize="15px"
                        color="#616161"
                        letterSpacing="0.1%"
                        lineHeight="20px"
                    >
                        Estado del título:
                    </Text>
                    <Badge status={tracking.state}>
                        {tracking.state === 'Entregado a participante' ? (
                            <>
                                <Icon
                                    icon="circum:circle-check"
                                    width="24"
                                    height="24"
                                />
                                <Name>Entregado</Name>
                            </>
                        ) : (
                            <>
                                <Icon
                                    icon="mdi-light:clock"
                                    width="24"
                                    height="24"
                                />
                                <Name>{tracking.state}</Name>
                            </>
                        )}
                    </Badge>
                    {tracking?.degree_send_follow_number !== '' && (
                        <>
                            <DividerTitulationModal color={'#A8A8A8'} />
                            <IdTrackingDiv>
                                <RowDetails>
                                    <Text
                                        fontSize="12px"
                                        fontWeight={700}
                                        color="#000000"
                                        textAlign="center"
                                        lineHeight="24px"
                                    >
                                        Medio de envío:{' '}
                                    </Text>

                                    <Text
                                        fontSize="12px"
                                        fontWeight={400}
                                        color="#616161"
                                        textAlign="center"
                                        lineHeight="24px"
                                    >
                                        {tracking?.shipping_medium
                                            ? tracking?.shipping_medium
                                            : '-'}
                                    </Text>
                                </RowDetails>
                                <RowDetails>
                                    <Text
                                        fontSize="12px"
                                        fontWeight={700}
                                        color="#000000"
                                        textAlign="center"
                                        lineHeight="24px"
                                    >
                                        Número de seguimiento:{' '}
                                    </Text>

                                    <Text
                                        fontSize="12px"
                                        fontWeight={400}
                                        color="#616161"
                                        textAlign="center"
                                        lineHeight="24px"
                                    >
                                        {tracking?.degree_send_follow_number
                                            ? tracking?.degree_send_follow_number
                                            : '-'}{' '}
                                    </Text>
                                </RowDetails>
                            </IdTrackingDiv>
                        </>
                    )}

                    <DividerTitulationModal color={'#A8A8A8'} />
                    {sortedTrackingMessages?.map((track, index) => (
                        <TrackingCard
                            key={index}
                            state={track?.state_name}
                            date={
                                track?.manual_state_changed_date !== false
                                    ? formatDate(
                                          track?.manual_state_changed_date,
                                          'DD/MM/YYYY'
                                      )
                                    : track?.state_changed_date !== false
                                      ? formatDate(
                                            track?.state_changed_date,
                                            'DD/MM/YYYY'
                                        )
                                      : ''
                            }
                            isCurrrentState={track?.is_current_state}
                            trackedStatus={
                                track?.manual_state_changed_date ||
                                track?.state_changed_date
                                    ? true
                                    : false
                            }
                            lastTracking={
                                sortedTrackingMessages.length - 1 === index
                            }
                        />
                    ))}
                </WrapperModal>
            </Modal>
        </>
    );
};

export default DegreeTrackingModal;
